import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/custom-attributes')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/campaigns/$campaignId/settings',
            params,
            hash: 'custom-attributes',
        })
    },
})
